import s from './notif.module.scss';

interface IProps {
  message: string;
}

export const Notif = ({ message }: IProps) => {
  return <div className={s.notif}>{message}</div>;
};
